import React from'react';// material
import Autocomplete from'components/v2/FormElements/Autocomplete';// import
var toptions=[{title:'A Training',label:'training'}];// These dropdowns arenow solely responsible for managing
// the state of the options that they convey
// All other configuration is based on hooks.
//
// They are shallow wrappers for Autocomplete.
export var AutocompleteTrainings=function AutocompleteTrainings(props){var selectProps={options:toptions};return React.createElement(Autocomplete,Object.assign({},selectProps,props));};